export default {
  404: "404",
  register: "Registrieren",
  login: "Anmelden",
  profit: "Gewinn",
  payout: "Ziel Auszahlung",
  btnDouble: "2×",
  wagered: "Gesetzt",
  deposit: "Einzahlen",
  inputFieldBtnMax: "Max",
  bets: "Wetten",
  topHeaderAmount: "Betrag",
  resetPasswordTitle: "Passwort zurücksetzen",
  resetPasswordNewPasswordTitle: "Neues Passwort",
  resetPasswordNewPasswordErrorsRequired: "Passwort ist erforderlich.",
  resetPasswordNewPasswordErrorsMinLength: "Mindestens 8 Zeichen erforderlich.",
  resetPasswordNewPasswordErrorsMaxLength: "Maximal 16 Zeichen erlaubt.",
  resetPasswordNewPasswordErrorsPattern:
    "Muss 8–16 Zeichen enthalten, einschließlich Groß- und Kleinbuchstaben, Zahlen und ein Sonderzeichen (z. B. NextGen@123)",
  resetPasswordConfirmPasswordTitle: "Passwort bestätigen",
  resetPasswordConfirmPasswordErrorsNotMatched:
    "Passwörter stimmen nicht überein.",
  resetPasswordResetBtn: "Zurücksetzen",
  passwordResetSuccess: "Passwort geändert",
  resetPasswordWentWrong: "Etwas ist schiefgelaufen!",
  partners: "Partner",
  submit: "Absenden",
  signinUsername: "E-Mail / Benutzername",
  signinForgetPassword: "Passwort vergessen?",
  signinErrorsUserNameRequired: "Bitte geben Sie Benutzername/E-Mail ein.",
  signinErrorsPasswordRequired: "Passwort ist erforderlich.",
  signinErrorsPasswordMinLength: "Mindestens 8 Zeichen erforderlich.",
  signinErrorsPasswordMaxLength: "Maximal 16 Zeichen erlaubt.",
  signinTryAgain: "Etwas ist schiefgelaufen! Bitte versuchen Sie es erneut.",
  signinResetPasswordUsernameErr:
    "Bitte geben Sie Benutzername/E-Mail ein, um Passwort zurückzusetzen.",
  signinResetMailSentSuccessContent:
    "Wir haben Ihnen einen Link zum Zurücksetzen des Passworts per E-Mail gesendet. Bitte prüfen Sie Ihre E-Mail und setzen Sie Ihr Passwort zurück.",
  signupTitle: "Registrieren",
  signupUsername: "Benutzername",
  signupEmail: "E-Mail",
  signupWalletConnect: "Mit Wallet anmelden",
  signupPassword: "Passwort",
  signupErrorsUserNameRequired: "Bitte geben Sie den Benutzernamen ein.",
  signupErrorsFirstNameRequired: "Bitte geben Sie den Vornamen ein.",
  signupErrorsLastNameRequired: "Bitte geben Sie den Nachnamen ein.",
  signupErrorsUserNameMinLength:
    "Mindestens {{minimumCharacters}} Zeichen erforderlich.",
  signupErrorsUserNameMaxLength:
    "Maximal {{maximumCharacters}} Zeichen erlaubt.",
  signupErrorsUserNamePattern: "Bitte nur Buchstaben und Zahlen eingeben.",
  signupErrorsStringPattern: "Bitte nur Buchstaben eingeben.",
  signupErrorsEmailRequired: "Bitte geben Sie eine E-Mail ein.",
  signupErrorsEmailPattern: "Bitte geben Sie eine gültige E-Mail ein.",
  signupErrorsPasswordRequired: "Passwort ist erforderlich.",
  signupErrorsPasswordMinLength: "Mindestens 8 Zeichen erforderlich.",
  signupErrorsPasswordMaxLength: "Maximal 16 Zeichen erlaubt.",
  signupErrorsPasswordPattern:
    "Muss 8–16 Zeichen enthalten, einschließlich Groß- und Kleinbuchstaben, Zahlen und ein Sonderzeichen (z. B. NextGen@123)",
  otpIsRequired: "OTP ist erforderlich",
  otpMustBeSixDigits: "OTP muss 6-stellig sein",
  enterOtp: "OTP eingeben",
  accountMenuTransactions: "Transaktionen",
  accountMenuPromotions: "Aktionen",
  accountMenuProfile: "Profil",
  accountMenuLogout: "Abmelden",
  accountMenuWithdraw: "Abheben",
  pageNotFound: "Die gesuchte Seite konnte nicht gefunden werden!",
  error: "Fehler",
  somethingWentWrong: "Etwas ist schiefgelaufen!",
  verifyEmailThankYou: "Danke!",
  verifyEmailEmailIsVerified: "Ihre E-Mail ist bestätigt.",
  verifyEmailWentWrong: "Etwas ist schiefgelaufen!",
  verifyEmailTokenExpired: "E-Mail bereits bestätigt oder Link abgelaufen",
  create: "Erstellen",
  profilePassword: "Passwort",
  profileUploadProfile: "Foto hochladen",
  profileErrorsEmailRequired: "E-Mail ist erforderlich.",
  profileErrorsEmailPattern: "Bitte geben Sie eine gültige E-Mail ein.",
  profileErrorsEmailMinLength: "Mindestens 3 Zeichen erforderlich.",
  profileErrorsEmailMaxLength: "Maximal 20 Zeichen erlaubt.",
  profileMessagesProfileUpdate: "Profil aktualisiert",
  profileMessagesChangePassword: "Passwort aktualisiert",
  profileProfilePicProfilePicUpload: "Profilbild hochladen",
  profileNoNewChanges:
    "Profil konnte nicht aktualisiert werden! Keine neuen Änderungen.",
  profileLoggedInWithSocial: "Sie haben sich über Social Login angemeldet.",
  profileSideNavigatorSound: "Sound",
  profileSideNavigatorMusic: "Musik",
  profileSideNavigatorProfile: "Mein Profil",
  profileSideNavigatorBetHistory: "Wettverlauf",
  profileSideNavigatorTransactions: "Transaktionen",
  profileSideNavigatorDeposit: "Einzahlen",
  withdraw: "Abheben",
  profileSideNavigatorGameLimits: "Spielgrenzen",
  profileSideNavigatorReferral: "Empfehlungen",
  profileSideNavigatorChangePassword: "Passwort ändern",
  profileSideNavigatorTermsConditions: "Geschäftsbedingungen",
  profileSideNavigatorLogOut: "Abmelden",
  profileSideNavigatorProvablyFair: "Nachweislich fair",
  WalletInfoSectionNotAvailable: "Nicht verfügbar",
  WalletInfoSectionRealBalance: "Echtes Guthaben",
  GameLimitsMinimumBet: "Mindestwette",
  GameLimitsMaximumBet: "Maximalwette",
  GameLimitsMaxWinFor1Bet: "Maximaler Gewinn für eine Wette",
  ProvablyFairSubTitle:
    "Dieses Spiel verwendet Provably Fair-Technologie, um das Spielergebnis zu bestimmen. Mit diesem Tool können Sie Ihren Seed ändern und die Fairness des Spiels überprüfen.",
  ProvablyFairMaximumBet: "Maximalwette:",
  ProvablyFairMaxWinFor1Bet: "Maximaler Gewinn für eine Wette",
  promotionsTitle: "Aktionen",
  promotionsNoLosingData:
    "Leider sind keine Verlustbonus-Aktionen verfügbar für ",
  promotionsNoDepositData:
    "Leider sind keine Einzahlungsbonus-Aktionen verfügbar für ",
  promotionsCurrency: " Währung.",
  promotionsViewBtn: "Ansehen",
  promotionsClaimSuccess: "Sie haben erfolgreich beansprucht",
  promotionsAvailability: "Verfügbarkeit: ",
  promotionsAvailabilityTabLosing: "Verlustbonus",
  promotionsAvailabilityTabDeposit: "Einzahlungsbonus",
  promotionsDepositBonusTableCode: "Code",
  promotionsDepositBonusTableMinDeposit: "Mind. Einzahlung",
  promotionsDepositBonusTablePercentage: "Prozentsatz",
  promotionsDepositBonusTableMaxBonus: "Maximaler Bonus",
  promotionsDepositBonusTableRolloverMultipler: "Rollover-Multiplikator",
  promotionsDepositBonusTableMaxRolloverPerBet: "Maximaler Rollover pro Wette",
  promotionsDepositBonusTableTimeToAchieveRolloverTarget:
    "Zeit, um das Rollover-Ziel zu erreichen",
  promotionsBonusCode: "BONUS CODE: ",
  promotionsLossesClaim:
    "Verluste können beansprucht werden (innerhalb der Kampagnenlaufzeit): ",
  promotionsLossesClaimLosingBonusTablePercentage: "Prozentsatz",
  promotionsLossesClaimLosingBonusTableMinLosingAmount: "Min. Verlustbetrag",
  promotionsBonusStatus: "Bonusstatus: ",
  promotionsBonusAmount: "Bonusbetrag: ",
  promotionsRolloverTarget: "Rollover-Ziel: ",
  promotionsRolloverAchieved: "Rollover erreicht: ",
  promotionsActivatebtn: "AKTIVIEREN",
  promotionsClaimBtn: "BEANSPRUCHEN",
  promotionsCancelBtn: "ABBRECHEN",
  promotionsBackBtn: "ZURÜCK",
  promotionsBonus: "Bonus",
  promotionsTermAndConditions: " Geschäftsbedingungen",
  promotionsClaimDepositBonusTitle:
    "Schritte zum Beantragen des Einzahlungsbonus",
  promotionsClaimDepositBonusFirst: "Bonuscode aktivieren",
  promotionsClaimDepositBonusSecond: "Betrag auf Wallet einzahlen",
  promotionsClaimDepositBonusThird:
    "Rollover-Ziel erreichen, um Bonus zu beanspruchen",
  promotionsClaimLosingBonusTitle: "Schritte zum Beantragen des Verlustbonus",
  promotionsClaimLosingBonusFirst: "Bonuscode aktivieren",
  promotionsClaimLosingBonusSecond: "Spiele deine Lieblingsspiele",
  promotionsClaimLosingBonusThird:
    "Klicke auf ’Verluste beanspruchen’, um Verluste innerhalb der Kampagnenlaufzeit zu beanspruchen",
  promotionsWentWrong: "Etwas ist schiefgelaufen!",
  transactionTitle: "Transaktionen",
  transactionBetId: "Wett-ID",
  transactionUser: "Benutzer",
  transactionPayout: "Auszahlung",
  transactionAmount: "Betrag",
  transactionTime: "Datum",
  transactionProfit: "Gewinn",
  transactionCashout: "Auszahlen",
  transactionBet: "Wette",
  transactionMultix: "Multi.x",
  transactionWin: "Gewinn",
  transactionFairness: "Fairness",
  transactionReferFriend: "Freund werben",
  transactionTotal: "Gesamtwetten",
  transactionWins: "Gewinne",
  transactionRefresh: "Aktualisieren",
  transactionFilterTopMultipliers: "Top-Multiplikatoren",
  transactionFilterHugeWins: "Große Gewinne",
  transactionFilterBiggestWins: "Größte Gewinne",
  transactionFilterMultipliers: "Multiplikatoren",
  transactionRealBalance: "Echtes Guthaben",
  depositWithdrawTXDate: "Datum",
  depositWithdrawTXAmount: "Betrag",
  depositWithdrawTXTxId: "TxID",
  depositWithdrawTXTxType: "Transaktionstyp",
  depositWithdrawTXStatus: "Status",
  depositWithdrawTXNoData: "Keine Daten verfügbar.",
  depositTitle: "Einzahlen",
  depositHistory: "Verlauf",
  depositSubTitle:
    "Benutzer können keine Fiat-Währung einzahlen oder abheben. Bitte kontaktieren Sie den Admin, um in Fiat-Währung zu transagieren.",
  depositCopyNotSupported:
    "Ihr Browser unterstützt das automatische Kopieren in die Zwischenablage nicht.\nBitte versuchen Sie, den Code manuell zu kopieren.",
  depositCopied: "Adresse kopiert.",
  withdrawNoBalance: "Nicht genügend Guthaben.",
  withdrawMinAmount:
    "Bitte geben Sie einen Betrag größer oder gleich {{min}} ein.",
  paginationNextBtn: "Weiter",
  paginationPrevBtn: "Zurück",
  LoginRequired: "Anmeldung erforderlich!",
  betPlacedSuccessfully: "Wette platziert",
  betCancelledSuccessfully: "Wette erfolgreich storniert",
  PlayerEscapedSuccessfully: "Spieler hat das Spiel verlassen",
  CopiedSuccessfull: "Erfolgreich kopiert",
  usersConsent:
    "Durch den Zugriff auf diese Seite bestätige ich, dass ich 18 Jahre alt bin und die",
  termsOfService: "Nutzungsbedingungen",
  email: "E-Mail",
  playNow: "Jetzt spielen",
  orContinueWith: "Oder fortfahren mit",
  metamaskExtensionNotAvailable:
    "Bitte installieren Sie die MetaMask-Erweiterung und aktualisieren Sie die Seite.",
  cashier: "EINZAHLUNG",
  account: "KONTO",
  hello: "Hallo",
  balance: "Guthaben",
  referrals: "Empfehlungen",
  settings: "Einstellungen",
  withdrawals: "Abhebungen",
  demoWallet: "Demo Wallet",
  wallet: "Wallet",
  user: "Benutzer",
  amountIsRequired: "Betrag ist erforderlich",
  minDepositAmount: "Einzahlungsbetrag muss größer als {{min}} sein.",
  maxDepositAmount: "Einzahlungsbetrag muss kleiner als {{max}} sein.",
  minWithdrawAmount: "Muss größer als {{min}} sein",
  withdrawMustLessThanWallet:
    "Abhebungsbetrag muss kleiner als Ihr Wallet-Guthaben sein",
  accountTypeIsRequired: "Kontotyp ist erforderlich.",
  mobileNumberLength: "Handynummer muss {{length}} Ziffern haben",
  phoneIsRequired: "Telefonnummer ist erforderlich",
  cpfError: "CPF muss {{length}} Zeichen lang sein",
  cpfRequiredError: "CPF ist erforderlich",
  cnpjError: "CNPJ muss {{length}} Zeichen lang sein",
  mainMenu: "HAUPTMENÜ",
  casino: "Casino",
  sports: "Sport",
  crypto: "Krypto",
  NextGenXp: "NextGen XP",
  playEarn: "spielen & verdienen",
  NFT: "NFT",
  poker: "Poker",
  earnRewards: "BELONUNGEN VERDIENEN",
  rankUp: "Aufsteigen",
  inviteFriends: "Freunde einladen",
  affiliates: "Partner",
  sportsbook: "Sportwetten",
  menu: "Menü",
  allBets: "Alle Wetten",
  highRollers: "High Roller",
  luckyBets: "Glücks-Wetten",
  trade: "Handeln",
  player: "SPIELER",
  time: "ZEIT",
  wager: "WETTE",
  payoutText: "AUSZAHLUNG",
  bannerHeadOne: "Erleben Sie echte Innovation mit dem höchsten",
  bannerHeadTwo: "Belohnungsprogramm der Branche.",
  registerNow: "Jetzt registrieren",
  copy: "Kopieren",
  liveWins: "LIVE GEWINNE",
  monthlyStatus: "M",
  weeklyStatus: "W",
  dailyStatus: "D",
  nextEcosystem: "NextGen-Ökosystem",
  allGames: "Alle Spiele",
  allSports: "Alle Sportarten",
  cryptoFutures: "Krypto-Futures",
  tradeNow: "Jetzt handeln",
  allTables: "Alle Tische",
  nft: "NFT",
  viewAll: "Alle anzeigen",
  rewards: "Belohnungen",
  profile: "Profil",
  nextgenProfile: "NEXTGEN PROFIL",
  totalBets: "Gesamtwetten",
  totalWagered: "Insgesamt gesetzt",
  joinDate: "Beitrittsdatum",
  displaySocialLinks: "Verknüpfte Social-Accounts anzeigen",
  privateProfile: "Privates Profil",
  rank: "Rang",
  nextRank: "Nächster Rang",
  changeUsername: "Benutzername ändern",
  newPassword: "Neues Passwort",
  repeatNewPassword: "Neues Passwort wiederholen",
  changeName: "Name ändern",
  linkSocialAccount: "Social-Account verknüpfen",
  privateProfileTooltip:
    "Wenn Ihr Profil auf privat gesetzt ist, können andere Benutzer Ihre Wettaktivität, Belohnungen oder Social-Links nicht sehen.",
  socialLinksTooltip:
    "Verknüpfen Sie Ihre Social-Accounts, damit andere Benutzer Ihnen folgen können.",
  balances: "Guthaben",
  createReferralBalance: "Referral-Guthaben erstellen",
  total: "Gesamt",
  tips: "Tipps",
  receivedAmount: "Erhaltener Betrag",
  dateOrTime: "Datum/Zeit",
  view: "Ansehen",
  allChains: "Alle Chains",
  creditAmount: "Gutschriftbetrag",
  setCustomReferralLink: "Eigenen Referral-Link setzen",
  changeEmail: "E-Mail ändern",
  newEmail: "Neue E-Mail",
  newUsername: "Neuer Benutzername",
  username: "Benutzername",
  changePassword: "Passwort ändern",
  twoFactorAuthentication: "Zwei-Faktor-Authentifizierung",
  twoFactorAuthenticationTitle:
    "Die Verwendung der Zwei-Faktor-Authentifizierung wird dringend empfohlen, da sie Ihr Konto sowohl mit Passwort als auch mit Ihrem Telefon schützt. Um 2FA zu aktivieren, müssen E-Mail und Passwort gesetzt sein. Solange 2FA aktiviert ist, können Sie sich nicht über Steam anmelden.",
  enable2fa: "2FA aktivieren",
  verifyIdentityByKyc: "Identität verifizieren (KYC)",
  oldPassword: "Altes Passwort",
  live: "Live",
  soccer: "Fußball",
  tennis: "Tennis",
  fifa: "Fifa",
  basketball: "Basketball",
  iceHockey: "Eishockey",
  volleyball: "Volleyball",
  tableTennis: "Tischtennis",
  baseball: "Baseball",
  golf: "Golf",
  boxing: "Boxen",
  myBets: "Meine Wetten",
  favourites: "Favoriten",
  americanFootball: "American Football",
  buyCrypto: "Krypto kaufen",
  oldEmail: "Alte E-Mail",
  loggedInSuccess: "Anmeldung erfolgreich",
  loggedOutSuccess: "Abmeldung erfolgreich",
  signup: "Registrierung abgeschlossen",
  tokenVerify: "Verifikationstoken an Ihre E-Mail gesendet. Bitte bestätigen",
  emailVerify: "E-Mail bestätigt",
  emailChangedSuccess: "E-Mail aktualisiert",
  emailUpdateOtp: "OTP an neue E-Mail gesendet",
  profileUpdatedSuccess: "Profil aktualisiert",
  otpVerified: "Einmalpasswort (OTP) bestätigt",
  twoFADeactivated: "Zwei-Faktor-Authentifizierung deaktiviert",
  internalServerError: "Interner Serverfehler",
  unAuthorized: "Nicht autorisiert",
  dataNotFound: "Daten nicht gefunden",
  setReferralLink: "Referral-Link setzen...",
  notFound: "Nicht gefunden",
  nextgenOriginals: "NextGen Originals",
  status: "Status",
  success: "Erfolg",
  failed: "Fehlgeschlagen",
  pending: "Ausstehend",
  date: "Datum",
  to: "Bis",
  roundId: "Runden-ID",
  bet: "Wette",
  win: "Gewinn",
  at: "um",
  downloadAll: "Alle herunterladen",
  gameText: "Spiel",
  searchGames: "Spiele suchen",
  provider: "Anbieter",
  search: "Suche",
  all: "Alle",
  sortBy: "Sortieren nach",
  popular: "Beliebt",
  loadMore: "Mehr laden",
  bitcoin: "Bitcoin",
  btc: "BTC",
  chat: "Chat",
  loginToChat: "Zum Chat anmelden",
  send: "Senden",
  expand: "Erweitern",
  collapse: "Reduzieren",
  emailPlaceholder: "ihreemail@domain.com",
  removeFromFavourite: "Aus Favoriten entfernen",
  addToFavourite: "Zu Favoriten hinzufügen",
  verify: "Verifizieren",
  accountVerification: "Konto-Verifikation",
  recentlyPlayed: "Zuletzt gespielt",
  moreFrom: "Mehr von",
  demoMode: "Demo-Modus",
  providersList: "Anbieterliste",
  games: "Spiele",
  providers: "Anbieter",
  close: "Schließen",
  joinedOn: "Beigetreten am",
  rewarded: "Belohnt",
  saySomething: "Sag etwas",
  addressIsRequired: "Adresse ist erforderlich",
  withdrawRequestSent: "Abhebungsanfrage gesendet. Warte auf Genehmigung.",
  noMatchesFound: "Keine Spiele gefunden",
  tip: "Trinkgeld",
  sendTip: "Trinkgeld senden",
  minAmount: "Betrag muss größer als {{min}} sein",
  maxAmount: "Betrag muss kleiner als {{max}} sein",
  doNotShowTip: "Trinkgeld im Chat nicht anzeigen",
  demoAvailable: "Demo verfügbar",
  denoNotAvailable: "Demo nicht verfügbar",
  goFullscreen: "Vollbildmodus",
  endsAt: "Endet um",
  inProgress: "In Bearbeitung",
  eventEnd: "Ende des Events",
  latestPromotions: "Neueste Aktionen",
  archived: "Archiviert",
  noPromotionsFound: "Keine Aktionen gefunden",
  claim: "Beanspruchen",
  add: "Hinzufügen",
  viewDashboard: "Dashboard anzeigen",
  prize: "Preis",
  timeLeft: "Verbleibende Zeit",
  viewTransactions: "Transaktionen anzeigen",
  sendAmountInCashier:
    "Senden Sie den Betrag von {{- currency}} Ihrer Wahl an die folgende Adresse, um den entsprechenden Betrag in Coins zu erhalten.",
  yourPersonalDepositAddress:
    "Ihre persönliche {{- currency}} Einzahlungsadresse",
  copyAddress: "Adresse kopieren",
  theValueOfCurrencyMayChange:
    "Der Wert von {{- currency}} kann sich zwischen jetzt und dem Zeitpunkt ändern, an dem wir Ihre Zahlung erhalten.",
  doNotHaveAnyCurrency: "Haben Sie keine {{- currency}}?",
  depositOptions: "Einzahlungsoptionen",
  withdrawalOptions: "Abhebungsoptionen",
  withdrawCurrency: "Abheben von {{- currency}}",
  enterAddressToReceiveFunds:
    "Bitte geben Sie die {{- currency}} Wallet-Adresse ein, auf die Sie die Gelder erhalten möchten. Nach Bestätigung wird die Abhebung normalerweise innerhalb weniger Minuten verarbeitet.",
  receivingCurrencyAddress: "Empfangende {{- currency}} Adresse",
  withdrawalAmount: "Abhebungsbetrag",
  pasteYourCurrencyAddressHere:
    "Fügen Sie hier Ihre {{- currency}} Wallet-Adresse ein...",
  request: "Anfrage",
  receiveTheSpecifiedAmount:
    "*Sie erhalten den angegebenen {{- currency}} Betrag auf Ihre Abhebungsadresse",
  valueMayVary:
    "*Der von Ihrem Guthaben abgezogene Betrag kann zwischen jetzt und der Bearbeitung Ihrer Abhebung variieren",
  coupons: "Gutscheine",
  updateEmail: "E-Mail aktualisieren",
  update: "Aktualisieren",
  loginHistory: "Login-Verlauf",
  showLoginHistory: "Login-Verlauf anzeigen",
  wagerErr: "Wetteinsatz erforderlich",
  minWagerErr: "Mindesteinsatz ist 1",
  mulValErr: "Multiplikatorwert zwischen 1 - 1000",
  closeBetErr: "Geben Sie einen gültigen Close-Bet-Betrag ein",
  profitErr: "Geben Sie einen gültigen Take-Profit-Betrag ein",
  multiplierErr: "Multiplikatorbetrag erforderlich",
  manual: "Manuell",
  auto: "Automatisch",
  pnLFee: "PnL-Gebühr",
  flatFee: "Pauschalgebühr",
  takeProfitLabel: "TAKE PROFIT ZUM PREIS",
  closeBetLabel: "CLOSE BET ZUM PREIS",
  priceUpLabel: "WIRD DER PREIS STEIGEN ODER FALLEN?",
  up: "Steigend",
  down: "Fallend",
  payoutMul: "AUSZAHLUNGSMULTIPLIKATOR",
  safe: "Sicher",
  wild: "Wild",
  placeBet: "Wette platzieren",
  roundEnd: "RUNDE ENDET IN",
  timerInfo:
    "Alle Rollercoaster-Wetten werden täglich um 00:00 UTC geschlossen und der Preis wird auf $1.000 zurückgesetzt",
  month: "Monat",
  PNL: "PnL",
  ROI: "ROI",
  roi: "roi",
  funding: "Funding/H",
  exitPriceLabel: "Exit-Preis",
  cashedOut: "Ausgezahlt",
  open: "Offen",
  chartPreferences: "Diagramm-Einstellungen",
  yAxis: "Y-Achsen-Einstellungen",
  additionalFeatures: "Zusatzfunktionen",
  themes: "Themen",
  locale: "Sprache/Region",
  changeTimezone: "Zeitzone ändern",
  changeLanguage: "Sprache ändern",
  tooltip: "Tooltip",
  field: "Feld",
  value: "Wert",
  dateTime: "Datum/Zeit",
  winningAmount: "Gewinnbetrag",
  activeBets: "Aktive Wetten",
  closedBets: "Abgeschlossene Wetten",
  publicBets: "Öffentliche Wetten",
  leaderboard: "Rangliste",
  howToPlay: "Spielanleitung",
  rOICalculator: "ROI Rechner",
  allInstruments: "Alle Instrumente",
  week: "Woche",
  monthLabel: "Monat",
  day: "Tag",
  betLabel: "WETTE",
  entryPrice: "EINSTIEGSPREIS",
  bustPriceLabel: "Bust-Preis",
  multiplierLabel: "MULTIPLIKATOR",
  exitPrice: "EXIT-PREIS",
  pnl: "Gewinn & Verlust",
  details: "Details anzeigen",
  profitLoss: "Gewinn & Verlust",
  noBalance: "Nicht genügend Guthaben.",
  maxBetAmount: "Maximaler Wetteinsatz",
  limit: "Limit überschritten.",
  minBetAmount: "Mindestwetteinsatz",
  rollsLimitMsg: "Anzahl der Rolls muss kleiner oder gleich 100 sein.",
  mines: "Minen",
  loginFailed: "Login fehlgeschlagen",
  noEntries: "Keine Einträge",
  descriptionIsRequired: "Beschreibung erforderlich",
  description: "Beschreibung",
  report: "Melden",
  userReportedSuccessfully: "Benutzer gemeldet",
  tipSendSuccessfully: "Trinkgeld gesendet",
  walletSettings: "Wallet-Einstellungen",
  hideZero: "Null-Guthaben ausblenden",
  hideZeroInfo: "Ihr Null-Guthaben wird in Ihrem Wallet nicht angezeigt",
  displayFiat: "Krypto in Fiat anzeigen",
  displayFiatInfo:
    "Alle Wetten & Transaktionen werden im Krypto-Äquivalent abgerechnet",
  noteForApprox: "Bitte beachten Sie, dass dies ungefähre Währungswerte sind.",
  save: "Speichern",
  limits: "Limits",
  wagerLimit: "Wetteinsatzlimit",
  lossLimit: "Verlustlimit",
  depositLimit: "Einzahlungslimit",
  takeABreak: "Pause einlegen",
  customTimePeriod: "Benutzerdefinierter Zeitraum",
  timePeriod: "Zeitraum",
  selfExclusion: "Selbstausschluss",
  confirm: "Bestätigen",
  setLimit: "Limit setzen",
  removeLimit: "Limit entfernen",
  enterAmount: "Betrag eingeben",
  hours: "Stunden",
  daily: "Täglich",
  weekly: "Wöchentlich",
  monthly: "Monatlich",
  cancel: "Abbrechen",
  usedLimit: "Verwendetes Limit",
  type: "Art",
  updatedAt: "Aktualisiert am",
  editLimit: "Limit bearbeiten",
  limitRemovedMessage: "Ihr folgendes Limit wird entfernt.",
  setLimitMessage:
    "Sie sind dabei, folgendes Limit für Ihr Konto festzulegen. Bitte beachten Sie, dass Änderungen erst nach 24 Stunden wirksam werden.",
  setBreakMessage:
    "Sie blockieren den Zugriff auf Ihr Konto für einen voreingestellten Zeitraum. Nach Nutzung dieser Option können Sie sich nicht anmelden, um den Zeitraum zu ändern. Für andere Zeiträume oder Verlängerungen kontaktieren Sie bitte den Live-Support.",
  setSessionLimitMessage:
    "Sie sind dabei, folgendes Limit für Ihr Konto festzulegen. Bitte beachten Sie, dass Änderungen erst nach 24 Stunden wirksam werden, wenn Sie ein neues Limit setzen.",
  removeSessionLimitMessage: "Ihr Sitzungslimit wird entfernt",
  notAchieved: "nicht erreicht",
  flexibleRegistration: "Flexible Registrierung!",
  mostPlayed: "Meistgespielt",
  badge: "Abzeichen",
  allBadges: "Alle Abzeichen",
  socialMedia: "Soziale Medien",
  allLinks: "Alle Links",
  statistics: "Statistiken",
  newMessage: "Neue Nachricht",
  tipFor: "Trinkgeld für",
  play: "Spielen",
  betOn: "Wette auf",
  liveCasino: "Live Casino",
  ecosystemUnbeatableOdds:
    "Besser wetten – Zugriff auf unschlagbare Quoten bei spannenden Events mit unserer Top-Wettplattform!",
  startBetting: "Jetzt Wetten",
  ecosystemJoinTheFun:
    "Machen Sie mit – Entdecken Sie exklusive NextGen-Spiele und über +9.000 Casino-Favoriten!",
  futures: "Futures",
  ecosystemTrade:
    "NGB ist Ihr vertrauenswürdiges Tor zur Zukunft des immersiven Online-Gaming- und Wettplattform-Erlebnisses!",
  ecosystemCasino24x7:
    "Erleben Sie den Nervenkitzel des Echtzeit-Gamings mit professionellen Dealern jederzeit und überall. Tauchen Sie ein in nonstop Action!",
  joinNow: "Jetzt beitreten",
  noNotificationsFound: "Keine Benachrichtigungen gefunden",
  notifications: "Benachrichtigungen",
  lobby: "Lobby",
  rollercoaster: "NextGen Coaster",
  applyReferralCode: "Referral-Code anwenden",
  referralCode: "Referral-Code",
  referralLink: "Referral-Link",
  copyLink: "Link kopieren",
  referralLinkCopied: "Referral-Link kopiert",
  withdrawAddressCannotBeSame:
    "Die Abhebungsadresse darf nicht mit Ihrer Adresse übereinstimmen",
  userId: "Benutzer-ID",
  active: "Aktiv",
  inactive: "Inaktiv",
  currency: "Währung",
  hostGames: "Spiele veranstalten,",
  earnCrypto: "Krypto verdienen",
  inviteHostAndEarn:
    "Einladen, veranstalten & verdienen – Leiten Sie Ihre eigenen NextGen-Events",
  startEarning: "Verdienen starten",
  nextGen: "NextGen",
  whitePaper: "Whitepaper",
  deepDiveInto: "Tauchen Sie tief in die NextGen-Coin-Wirtschaft ein",
  learnMore: "Mehr erfahren",
  sport: "Sport",
  vipRanked: "VIP-Rang",
  betMoreEarnMore: "Mehr wetten, mehr verdienen – Maximieren Sie Ihr Potenzial",
  expiresAt: "Läuft ab am",
  upload: "Hochladen",
  pleaseSelectImage: "Bitte Bild auswählen",
  imageSizeMustLessThan: "Bildgröße muss kleiner als {{size}} MB sein",
  imageSizeFormat: "Verwenden Sie das Bildformat png, jpeg, jpg.",
  maxFileSize: "Max. Dateigröße: 2 MB",
  dragPosition: "Ziehen, um Position zu ändern",
  onlyNumbers: "Nur Zahlen",
  cannotBeRemoved: "Kann nicht entfernt werden",
  amountInBetween:
    "Betrag sollte zwischen täglich und monatlich liegen (einschließlich)",
  amountEqualOrGreater: "Betrag gleich oder größer als wöchentlich",
  amountEqualOrLess:
    "Betrag sollte gleich oder kleiner als wöchentlich und monatlich sein",
  cannotBeIncreased: "Kann nicht erhöht werden",
  enterPassword: "Passwort eingeben",
  sessionLimit: "Sitzungslimit",
  timePeriodRequired: "Zeitraum erforderlich",
  amountGTZero: "Betrag größer als Null",
  mma: "MMA",
  counterStrike: "Counter Strike",
  rugbyUnion: "Rugby Union",
  valorant: "Valorant",
  cricket: "Cricket",
  dota: "DOTA-2",
  rugbyLeague: "Rugby League",
  hilo: "Hilo",
  crash: "Crash",
  cancelBetSuccessfully: "Wette storniert",
  start: "Start",
  invalidBetAmount: "Ungültiger Wetteinsatz",
  zeroError: "Muss größer als 0 sein",
  flipCoin: "Münzwurf",
  customs: "Zoll",
  redeemCode: "GUTSCHEINCODE EINLÖSEN",
  couponText: "Wir posten diese regelmäßig auf unseren",
  copyrightText:
    "<aLink>{{website}}</aLink> is owned by {{companyName}}, a Limited Company registered in Cyprus. License Registration Number {{licenseNumber}}.",
  platform: "Plattform",
  support: "Support",
  faq: "FAQ",
  partnershipProgram: "Partnerprogramm",
  blog: "Blog",
  helpCenter: "Hilfezentrum",
  aboutUs: "Über uns",
  community: "Community",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  discord: "Discord",
  english: "Englisch",
  hindi: "Hindi",
  french: "Französisch",
  legal: "Rechtliches",
  cryptoTransactions: "Krypto-Transaktionen",
  sendersName: "Name des Absenders",
  hideLoginHistory: "Login-Verlauf ausblenden",
  loginMethod: "Login-Methode",
  deviceType: "Gerätetyp",
  ip: "IP",
  tradingDefinition:
    "Krypto-Handel ist definitionsgemäß kein Glücksspiel und fällt daher nicht unter unsere Glücksspiel-Lizenz.",
  perks: "Vorteile",
  connected: "Verbindung hergestellt",
  twitch: "Twitch",
  connect: "Verbinden",
  setUpGoogleAuthenticator: "GOOGLE AUTHENTICATOR EINRICHTEN",
  twoFACode: "2FA-CODE",
  downloadTheGoogleAuthenticator:
    "1. Laden Sie die Google Authenticator-App für iPhone oder Android herunter",
  saveTheFollowingAccountToken:
    "2. Speichern Sie den folgenden Account-Token (Schlüssel) an einem sicheren Ort",
  accountTokenKey: "Account-Token (Schlüssel)",
  scanQRCodeWithApp: "3. QR-Code mit der Google Authenticator-App scannen",
  enterTheTokenBelow: "4. Token unten eingeben",
  copied: "Kopiert",
  code: "Code",
  furtherVerificationRequired: "Weitere Verifizierung erforderlich",
  firstName: "Vorname",
  lastName: "Nachname",
  dateOfBirth: "Geburtsdatum",
  year: "Jahr",
  addressLine: "Adresszeile",
  addressLineTwo: "Adresszeile 2",
  city: "Stadt",
  province: "Provinz",
  postalCode: "Postleitzahl",
  country: "Land",
  submitInformation: "Informationen absenden",
  level: "Level",
  required: "Erforderlich",
  rejected: "Abgelehnt",
  completed: "Abgeschlossen",
  cancelled: "Abgebrochen",
  onHold: "In Bearbeitung",
  kycRequestSubmittedSuccessfully: "KYC-Anfrage eingereicht",
  reRequested: "Erneut angefordert",
  cashBalance: "Barguthaben",
  bonusBalance: "Bonusguthaben",
  specialBonus: "Sonderbonus",
  today: "Heute",
  noRewards: "Keine Belohnungen",
  viewPendingRewards: "Ausstehende Belohnungen anzeigen",
  totalClaimed: "Insgesamt beansprucht",
  pendingRewards: "Ausstehende Belohnungen",
  amount: "Betrag",
  others: "Andere",
  createdAt: "Erstellt am",
  horseRacing: "Pferderennen",
  addToHomeScreen: "NextGen zum Startbildschirm hinzufügen",
  oneTabAccess: "1-Tap-Zugriff auf Ihrem Telefon",
  install: "Installieren",
  addToHome: "Zum Startbildschirm hinzufügen",
  inChromeSafari: "In Chrome/Safari tippen Sie auf",
  buttonAndChoose: "Button und wählen Sie",
  afterCompletingThisStep:
    "Nach Abschluss dieses Schritts können Sie NextGen Bets mit einem Tipp auf Ihrem Telefon öffnen!",
  settlementId: "Abrechnungs-ID",
  commission: "Provision",
  totalCommission: "Gesamtprovision",
  commissionSettlement: "Provisionsabrechnung",
  startplaying: "Spiel starten",
  forgotPassword: "Passwort vergessen",
  resetPassword: "Passwort zurücksetzen",
  locked: "Gesperrt",
  unlocked: "Entsperrt",
  yourRank: "Ihr Rang",
  nextRanks: "Nächste Ränge",
  allRanks: "Alle Ränge",
  bonusClaimedSuccessfully: "Bonus beansprucht",
  passwordUpdated: "Passwort aktualisiert!",
  thatsOkayItHappens:
    "Das ist okay. Das passiert. Klicken Sie auf den Button unten, um fortzufahren. E-Mail",
  passwordsMustMatch: "Passwörter müssen übereinstimmen",
  youNearlyThere: "Sie sind fast da!",
  weSendYouVerificationEmail:
    "Wir haben Ihnen eine Verifizierungs-E-Mail gesendet. Bitte prüfen Sie Ihre E-Mails und bestätigen Sie Ihr Konto.",
  verifyEmailAddress: "E-Mail-Adresse bestätigen",
  pleaseNoteThatTheLinkWillExpire:
    "Bitte beachten Sie, dass dieser Link in 5 Tagen abläuft. Wenn Sie sich nicht bei NextGen Bets registriert haben, ignorieren Sie diese E-Mail. Danke",
  autoBetStops: "Automatische Wetten gestoppt, da Limit überschritten",
  casinoBets: "Casino-Wetten",
  sportsBet: "Sportwetten",
  cryptoTrades: "Krypto-Trades",
  customBets: "Benutzerdefinierte Wetten",
  nothingFound: "Nichts gefunden",
  bonus: "Bonus",
  claimedAt: "Beansprucht am",
  available: "Verfügbar",
  previous: "Vorherige",
  next: "Nächste",
  tooManyRequests: "Zu viele Anfragen.",
  limitUpdatedSuccessFully: "Limit erfolgreich aktualisiert",
  youLost: "Sie haben verloren",
  cashOutFailed: "Auszahlung fehlgeschlagen",
  betAlreadyPlaced: "Wette bereits platziert",
  betCashedOut: "Wette ausgezahlt",
  noFavouritesIn: "Keine Favoriten in",
  team: "NextGen Team",
  fiatAmount: "Fiat-Betrag",
  cryptoAmount: "Krypto-Betrag",
  moonpay: "Moonpay",
  paymentMethod: "Zahlungsmethode",
  transactionId: "Transaktions-ID",
  address: "Adresse",
  comingSoon: "Demnächst!",
  minOneCharacterRequired: "Mindestens ein Zeichen erforderlich",
  verifyOtp: "OTP überprüfen",
  noResults: "Keine Ergebnisse",
  moreFromBrand: "Mehr von NextGen Bets",
  cryptoDeposit: "Krypto-Einzahlung",
  cryptoWithdraw: "Krypto-Abhebung",
  fiatDeposit: "Fiat-Einzahlung",
  fiatWithdraw: "Fiat-Abhebung",
  goToPaymentsPage: "Zur Zahlungsseite gehen.",
  bankTransfer: "Banküberweisung",
  initiateTransfer: "Überweisung initiieren",
  emt: "EMT",
  initiateEmt: "EMT initiieren",
  checkYourMailForFurtherDetails:
    "Überprüfen Sie Ihre E-Mail für weitere Details",
  gigadet: "Gigadet",
  wallet88: "Wallet88",
  select_language: "Sprache auswählen",
  raise_a_ticket: "Ticket erstellen",
  view_website: "Webseite anzeigen",
  back_home: "Zurück zur Startseite",
};
